import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service'
import { AuthService } from 'app/_utils/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: WebSocket;
  public messages: Subject<string> = new Subject<string>();
  private shouldReconnect = true;
  private reconnectionDelay = 5000;
  private listeningVehicles: string;
  private messageInterval;

  constructor(private readonly cs: CookieService){}

  private async fetchTicket(at: string): Promise<string> {
    const response = await fetch(environment.endPointApiWebsocketTicket, {
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + at }
    });
    if (!response.ok) {
      throw new Error('No se pudo obtener el ticket: ' + response.status);
    }
    const data = await response.json();
    return data.ticket;
  }

  public async connect(): Promise<void> {
    this.shouldReconnect = true;

    if (this.socket) {
      console.log('Cerrando conexión WebSocket existente');
      this.socket.onclose = null;
      this.socket.close();
    }

    const at = await AuthService.getAt();
    let ticket: string;
    try {
      ticket = await this.fetchTicket(at);
    } catch (error) {
      console.log('Error obteniendo ticket:', error);
      throw error;
    }

    return new Promise((resolve, reject) => {
      const url = `${environment.endPointApiWebsocket}?ticket=${ticket}&freshMetadata=true`;
      this.socket = new WebSocket(url);

      this.socket.onopen = () => {
        console.log('Nueva conexión WebSocket exitosa');
        resolve();
        if (this.listeningVehicles) {
          this.sendMessage(this.listeningVehicles);
        }
        this.messageInterval = setInterval(() => {
          if (this.listeningVehicles) {
            console.log('Enviando vehículos:', this.listeningVehicles);
            this.sendMessage(this.listeningVehicles);
          }
        }, 30 * 60 * 1000);
      };

      this.socket.onmessage = (event) => {
        this.messages.next(event.data);
      };

      this.socket.onerror = (event) => {
        console.log('Error en la conexión del WebSocket:', event);
        reject(new Error('Error en la conexión del WebSocket'));
      };

      this.socket.onclose = (event) => {
        console.log('WebSocket cerrado:', event);
        if (this.shouldReconnect) {
          setTimeout(() => this.connect(), this.reconnectionDelay);
        }
      };
    });
  }

  public sendMessage(message: string): void {
    this.listeningVehicles = message;
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    } else {
      console.log('WebSocket no está abierto. No se puede enviar el mensaje.');
    }
  }

  public disconnect(): void {
    this.shouldReconnect = false;
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
    if (this.socket) {
      console.log('Cerrando conexión WebSocket');
      this.socket.close();
    }
  }
}
